// extracted by mini-css-extract-plugin
export default {"menu":"CustomNavBar_menu__YxbbS","menuItem":"CustomNavBar_menuItem__ASKbX","active":"CustomNavBar_active__heLTi"};